import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

// project imports
import useAuth from 'hooks/useAuth';
import { useDispatch, useSelector } from 'store';

// ==============================|| AUTH GUARD ||============================== //

/**
 * Authentication guard for routes
 * @param {PropTypes.node} children children element/node
 */
const AuthGuard = ({ children }) => {
    const { isLoggedIn, setPrevRoute } = useAuth();

    const navigate = useNavigate();
    const prevLocation = useLocation();

    useEffect(() => {
        if (!isLoggedIn) {
            setPrevRoute(prevLocation.pathname);
            navigate(`auth`, { replace: true });
        }
    }, [isLoggedIn, navigate, prevLocation?.pathname]);

    return children;
};

AuthGuard.propTypes = {
    children: PropTypes.node
};

export default AuthGuard;
